import { render, staticRenderFns } from "./OrderCreatorServicePackage.vue?vue&type=template&id=5ff35fad&scoped=true&"
import script from "./OrderCreatorServicePackage.vue?vue&type=script&lang=js&"
export * from "./OrderCreatorServicePackage.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreatorServicePackage.vue?vue&type=style&index=0&id=5ff35fad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff35fad",
  null
  
)

export default component.exports